export default "__VITE_ASSET__DBeTMMTI__"